import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from "../../../environments/environment";
import {Activity, SchedulingParams} from "../../domain/cloud-topology";
import {AuthGuardService} from "../auth-guard.service";
import moment from 'moment-timezone';
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  constructor(private http: HttpClient) { }

  getActivityStatuses(): Observable<string[]> {
    return this.http.get(environment.schedulesUrl + '/activity-statuses').pipe(map(res => res['data']));
  }

  getActivityTypes(): Observable<string[]> {
    return this.http.get(environment.schedulesUrl + '/activity-types').pipe(map(res => res['data']));
  }

  getSchedules(filter: SchedulingParams): Observable<Activity[]> {
    let optionalParams: {} = {};
    optionalParams['startDate'] = filter.startDate;
    optionalParams['stopDate'] = filter.stopDate;
    if (filter.accounts) {
      optionalParams['accounts'] = filter.accounts;
    }

    if (filter.developers) {
      optionalParams['developers'] = filter.developers;
    }

    if (filter.sites) {
      optionalParams['sites'] = filter.sites;
    }

    if (filter.programs) {
      optionalParams['programs'] = filter.programs;
    }

    if (filter.activityTypes) {
      optionalParams['activityTypes'] = filter.activityTypes;
    }

    if (filter.systemTypes) {
      optionalParams['systemTypes'] = filter.systemTypes;
    }

    if (filter.activityStatuses) {
      optionalParams['status'] = filter.activityStatuses;
    }

    const params: HttpParams = new HttpParams({
      fromObject: optionalParams,
    });

    return this.http.get(environment.schedulesUrl, {
        params: params
    }).pipe(map(res => res['data']));
  }

  postStopActivities(id: String): Observable<any> {
    return this.http.post(environment.schedulesUrl + `/stop-activities/${id}`, {}).pipe(map(res => res['data']));
  }
}
